import React, { ChangeEvent, useMemo } from 'react';
import CustomTextArea from '../../custom/CustomTextArea';
import { AccordionIndicator, AccordionOpenCloseIcon } from '../../custom/AccordionIndicators';
import SarAccordionSectionHeader from './SarAccordionSectionHeader';
import SarValidationCategoryMapper from '../../../util/SarValidationCategoryMapper';
import { SarValidationResult } from '../SarInterfaces';

const BildirimAciklamaSection = ({ xmlContent, fallbackValue, onChange, validate }: Props) => {
  const hasError = useMemo<boolean>(() => {
    if (!validate || !validate.errors || validate.errors.length === 0) {
      return false;
    }
    const invalidTags = SarValidationCategoryMapper.getInvalidXmlTags(validate.errors);
    return invalidTags.has('bildirimaciklama');
  }, [validate]);
  const value = useMemo(() => {
    if (!xmlContent || xmlContent.trim().length === 0) {
      return fallbackValue;
    }
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlContent, 'text/xml');
    const element = xmlDoc.getElementsByTagName('bildirimaciklama')[0];
    return element && element.textContent ? element.textContent : fallbackValue;
  }, [xmlContent, fallbackValue]);

  return (
    <div className={'h-full w-full pr-6 pt-3 2xl:pt-4 flex flex-col gap-y-3'}>
      <div className={'text-[#1D2939] text-base font-semibold'}>XML Document</div>
      <div className={'flex flex-col border rounded-[10px] h-full overflow-y-auto overflow-hidden'}>
        <div className={'flex w-full items-center justify-between px-5 2xl:px-6 h-[56px] 2xl:h-[58px] text-left bg-white border-b border-[#F2F4F7]'}>
          <div className={'flex items-center gap-x-3'}>
            <AccordionOpenCloseIcon hasError={hasError} expanded={true} />
            <SarAccordionSectionHeader hasError={hasError} label={'Bildirim Açıklama'} fieldPath={'bildirimAciklama'} />
          </div>
          <AccordionIndicator expanded={true} hasError={hasError} />
        </div>
        <div className={'flex flex-col'}>
          <div className={'border-t border-[#F2F4F7] bg-white px-6 py-4 flex flex-col gap-y-3'}>
            <div className='flex items-start gap-x-2'>
              <CustomTextArea
                className={`flex-1 border-[1px] px-3 border-[#E0E4E8] rounded-[4px] min-h-[200px] ${hasError ? 'border-f-red-1 border rounded-[4px] placeholder:text-f-red-1 text-f-red-1' : ''}`}
                placeholder={'Bildirim Açıklama'}
                value={value}
                onChange={onChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

interface Props {
  xmlContent?: string;
  fallbackValue: string;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  validate?: SarValidationResult;
}

export default BildirimAciklamaSection;
